import { createRouter as createTanStackRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import { RouteErrorPage } from './components/not-found'

export function getRouter() {
  const router = createTanStackRouter({
    routeTree,
    scrollRestoration: ({ location }) =>
      location.pathname !== '/' || Boolean(location.hash),
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 0,
    // Reports caught route errors to PostHog error tracking (see component).
    defaultErrorComponent: RouteErrorPage,
  })

  return router
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof getRouter>
  }
}
